import React from 'react';
import LegalPage from './LegalPage';
import { Shield } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <LegalPage 
      title="Datenschutzerklärung" 
      contentKey="legal_privacy"
      icon={Shield}
    />
  );
};

export default PrivacyPage;
